// extracted by mini-css-extract-plugin
export default {"body_wrapper":"QModal_body_wrapper__ziYFF","wrapper":"QModal_wrapper__jy3Zs","closeBtn":"QModal_closeBtn__hqGr+"};